module.exports = __webpack_public_path__ + "static/media/web3_dev.035e2b10.png";